import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isSuccess: false,
    hasError: false,
    isLoading: false,
    introduce: {}
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.INTRODUCE_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false
            };
        case ActionTypes.INTRODUCE_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case ActionTypes.ADD_INTRODUCE_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                introduce: payload
            };
        case ActionTypes.GET_INTRODUCE_BY_TYPE_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                introduce: payload
            };
        default:
            return state;
    }
};
